const ActivityTypesService = {

  parseActivityType: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      name: response.name,
      hasDuration: response.hasDuration,
      hasDistance: response.hasDistance,
      hasReps: response.hasReps,
      hasWeight: response.hasWeight,
      hasSets: response.hasSets,
      _links: response._links,
      _forms: response._forms
    };
  }

};

export default ActivityTypesService;



// WEBPACK FOOTER //
// ./src/api/services/activityTypesService.js